import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function CheckCircleLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 11.3926V12.3126C21.9988 14.469 21.3005 16.5673 20.0093 18.2944C18.7182 20.0216 16.9033 21.2851 14.8354 21.8965C12.7674 22.5079 10.5573 22.4345 8.53447 21.6872C6.51168 20.9399 4.78465 19.5587 3.61096 17.7497C2.43727 15.9406 1.87979 13.8007 2.02168 11.6489C2.16356 9.49717 2.99721 7.44893 4.39828 5.80968C5.79935 4.17043 7.69279 3.02799 9.79619 2.55275C11.8996 2.07752 14.1003 2.29495 16.07 3.17261"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 4.3125L12 14.3225L9 11.3225"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
